import client from './client'
import { UserResponse, UserLoginResponse, UserLogoutResponse } from '@/models'

export default {
  start: async (form: { email: string }) => client.post('nopaid_start', { form }).then(({ data }) => data),
  login: async (form: { loginId: string; loginPw: string }) =>
    client.post<{ user: UserLoginResponse }>('paid_login', { form }).then(({ data }) => data.user),
  logout: async () => client.get<{ user: UserLogoutResponse }>('paid_logout').then(({ data }) => data.user),
  get: async (params: { cd: string }) =>
    client.get<{ user: UserResponse }>('get_user_data', { params }).then(({ data }) => data.user),
}
